/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
// Dependencies
import React, {useEffect, useState, useRef} from 'react'
import {connect} from 'react-redux'
import ReactMarkdown from 'react-markdown'
import Helpers from '../Helpers'

// Components
import AtlsButton from './AtlsButton'
import LogTable from './LogTable'

// Images
import clockClockwise from '../images/ClockClockwise.svg'
// import carrotLeft from '../images/CarrotLeft.svg'
import carrotRight from '../images/CarrotRight.svg'

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesModuleLogList from '../styles/ModuleLogList.module.css'
import stylesCoreModule from '../styles/CoreModule.module.css'
import {Button, Icon, Modal2, Table, TableEntry, Animation} from '@lazarusai/forms-ui-components'

function CoreModule(props) {
  const [isModuleModalShowing, setIsModuleModalShowing] = useState(false)
  const [summaryLogEntries, setSummaryLogEntries] = useState([])
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [summaries, setSummaries] = useState([
    // {
    //   text: 'Lorem ipsum dolor sit amet consectetur. Vivamus urna et arcu amet ornare ullamcorper eros. Magna gravida elementum nunc eget nec aliquam. Sed nulla lacus neque lectus scelerisque sagittis dignissim. Lorem ipsum dolor sit amet consectetur. Vivamus urna et arcu amet ornare ullamcorper eros. Lorem ipsum dolor sit amet consectetur. Vivamus urna et arcu amet ornare ullamcorper eros. Magna gravida elementum nunc eget nec aliquam. Sed nulla lacus neque lectus scelerisque sagittis dignissim. Lorem ipsum dolor sit amet consectetur. Vivamus urna et arcu amet ornare ullamcorper eros. Lorem ipsum dolor sit amet consectetur. Vivamus urna et arcu amet ornare ullamcorper eros. Magna gravida elementum nunc eget nec aliquam. Sed nulla lacus neque lectus scelerisque sagittis dignissim. Lorem ipsum dolor sit amet consectetur. Vivamus urna et arcu amet ornare ullamcorper eros. Lorem ipsum dolor sit amet consectetur. Vivamus urna et arcu amet ornare ullamcorper eros. Magna gravida elementum nunc eget nec aliquam. Sed nulla lacus neque lectus scelerisque sagittis dignissim. Lorem ipsum dolor sit amet consectetur. Vivamus urna et arcu amet ornare ullamcorper eros.',
    //   time: 1728485786390,
    // },
    // {
    //   text: 'Summary 2',
    //   time: 1728492121727,
    // },
  ])
  const [selectedSummaryId, _setSelectedSummaryId] = useState(0)
  const selectedSummaryIdRef = useRef(0)

  function setSelectedSummaryId(data) {
    _setSelectedSummaryId(data)
    selectedSummaryIdRef.current = data
  }

  function downloadPDF() {
    setIsLoadingPDF(true)
    const body = {
      'apiKey': process.env.REACT_APP_ATLS_KEY,
    }
    Helpers.fetchPostPDF(process.env.REACT_APP_ATLS + 'conclude', body)
        .then(async (res) => {
          const blob = await res.blob()
          const newBlob = new Blob([blob], {type: 'application/pdf'})
          const blobUrl = window.URL.createObjectURL(newBlob)
          const link = document.createElement('a')
          link.href = blobUrl
          const fileName = 'ATLS_Summary_' + Date.now()
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)
          // clean up Url
          window.URL.revokeObjectURL(blobUrl)
        })
        .catch((err) => {
          console.log('error', err)
        })
        .finally(() => {
          setIsLoadingPDF(false)
        })
  }

  function separateString(s) {
    const parts = s.split('/')
    if (parts.length !== 3) {
      return ''
    }
    const x = parts[0]
    const y = parts[1]
    const z = parts[2]
    return [x, y, z]
  }

  const getElapsed = (timestamp) => {
    return Date.now() - timestamp
  }

  const getMinutes = (elapsed) => {
    return Math.floor(elapsed / 60000)
  }

  const [elapsed, setElapsed] = useState(getElapsed(Date.now()))

  useEffect(() => {
    setElapsed(getElapsed(selectedSummaryIdRef.current))
    const intervalId = setInterval(() => {
      const newElapsed = getElapsed(selectedSummaryIdRef.current)
      if (newElapsed !== elapsed) {
        setElapsed(newElapsed)
      }
    }, 1000)
    return () => clearInterval(intervalId)
  }, [summaries, selectedSummaryIdRef.current])

  useEffect(() => {
    if (props.summaries && Object.keys(props.summaries)?.length) {
      const sortedSummaries = Object.keys(props.summaries)?.sort().reverse().map((time) => {
        return (
          {
            time,
            id: time,
            text: props.summaries[time].summary,
            errors: props.summaries[time].errors,
            task_ids: props.summaries[time].task_ids,
          }
        )
      })
      setElapsed(getElapsed(parseInt(selectedSummaryIdRef.current)))
      setSummaries(sortedSummaries)
      if (!selectedSummaryIdRef?.current) {
        setSelectedSummaryId(Object.keys(props.summaries)[Object.keys(props.summaries).length - 1])
      }
    }
  }, [props.summaries])

  useEffect(() => {
    if (props.summaries?.[selectedSummaryIdRef.current]?.task_ids) {
      const newSummaryLogEntries = props.summaries?.[selectedSummaryIdRef.current]?.task_ids?.map((task) => {
        const taskWithoutSlash = task[0] === '/' ? task.slice(1, task.length) : task
        const summaryArr = separateString(taskWithoutSlash)
        if (summaryArr && summaryArr.length === 3) {
          const taskAndTimestamp = summaryArr[2]?.split('_')
          const task = taskAndTimestamp?.[0] || 'N/A'
          const timeStamp = parseInt(taskAndTimestamp?.[1])
          const time = timeStamp ? Helpers.timeStampToDateAndTime(timeStamp) : 'N/A'
          return (
            <TableEntry
              key={`task-${taskWithoutSlash}`}
              content={[
                summaryArr[0] || 'N/A',
                task,
                time,
              ]}
            />
          )
        } else {
          return (
            ''
          )
        }
      })
      setSummaryLogEntries(newSummaryLogEntries)
    }
  }, [summaries, selectedSummaryId])

  return (
    <>
      <div
        className={`${stylesModuleLogList['module-log-list-card']} ${props.error ? stylesModuleLogList['error-card']: ''} ${props.warning ? stylesModuleLogList['warning-card']: ''}`}
        style={
          props.type === 'core' ?
            {
              background: 'linear-gradient(113deg, rgba(172, 172, 172, 0.32) 0%, rgba(156, 156, 156, 0.00) 110.84%), var(--surface-primary, #141414)',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            } :
            {}
        }
        onClick={() => {
          setIsModuleModalShowing(true)
        }}
      >
        <div
          className={stylesModuleLogList['mll-card-title']}
        >
          {props.title}
        </div>
        <div
          className={`${stylesModuleLogList['mll-card-title-status']} ${props.error ? stylesModuleLogList['mll-card-title-status-error'] : ''}`}
        >
          <div className={stylesModuleLogList['mll-card-title-status-icon']}></div>
          <div
            className={stylesModuleLogList['mll-card-title-status-text']}
          >
            {props?.error || props?.warning || 'ACTIVE'}
          </div>
        </div>
        <div className={stylesCoreModule['core-module']}>
          {props.summaries && Object.keys(props.summaries)?.length > 0 &&
            <>
              <p className={stylesCoreModule['core-title']}>Summary</p>
              <div className='flex'>
                <img className={stylesCoreModule['clock-icon']} src={clockClockwise} />
                <span className={stylesCoreModule['sub-text']}>Generated {getMinutes(elapsed)} minutes ago</span>
              </div>
              <div className={stylesCoreModule['summary-container']}>
                <ReactMarkdown className={stylesCoreModule['summary-text']}>{props.summaries?.[selectedSummaryIdRef.current]?.summary}</ReactMarkdown>
              </div>
              <footer className={stylesCoreModule['core-footer']}>
                <div className={stylesCoreModule['arrow-btn-container']}>
                  <img
                    onClick={(e) => {
                      e.stopPropagation()
                      const indexOfSummary = Object.keys(props.summaries).indexOf(selectedSummaryIdRef.current?.toString())
                      if (indexOfSummary) {
                        setSelectedSummaryId(Object.keys(props.summaries)[indexOfSummary - 1])
                      }
                    }}
                    src={carrotRight}
                    className={
                      `${stylesCoreModule['rotate-180']} ${Object.keys(props.summaries).indexOf(selectedSummaryIdRef.current) === 0 ? stylesCoreModule['darken'] : ''}`
                    }
                  />
                  <img
                    onClick={(e) => {
                      e.stopPropagation()
                      const indexOfSummary = Object.keys(props.summaries).indexOf(selectedSummaryIdRef.current?.toString())
                      if (indexOfSummary < Object.keys(props.summaries)?.length - 1) {
                        setSelectedSummaryId(Object.keys(props.summaries)[indexOfSummary + 1])
                      }
                    }}
                    src={carrotRight}
                    className={
                      `${Object.keys(props.summaries).indexOf(selectedSummaryIdRef.current) < Object.keys(props.summaries)?.length - 1 ? '' :
                      stylesCoreModule['darken']}`
                    }
                  />
                </div>
                {/* <AtlsButton
                  text={'View All'}
                  onClick={(e) => {
                    e.stopPropagation()
                    console.log('To do: build view-all')
                  }}
                  icon={'arrow-ios-forward-outline'}
                /> */}
              </footer>
            </>
          }
        </div>
      </div>
      <div
        style={{
          position: 'fixed',
          zIndex: '3',
        }}
      >
        <Modal2
          isVisible={isModuleModalShowing}
          theme={props.theme}
          height={'90'}
          width={'90'}
          style={{
            position: 'fixed',
            height: '90vh',
            width: '90vw',
            minWidth: '500px',
            minHeight: '300px',
          }}
          // contentStyle={{
          //   overflow: 'hidden',
          // }}
          contentContainerStyle={{
            overflow: 'hidden',
          }}
          showConfirm={false}
          showClose={true}
          onDismiss={() => {
            setIsModuleModalShowing(false)
          }}
          title={props.title}
          hasLine={false}
          className={stylesModuleLogList['mll-modal']}
        >
          <div
            className={`${stylesModuleLogList['mll-modal-status-row']} ${props.error ? stylesModuleLogList['error-modal']: ''} ${props.warning ? stylesModuleLogList['warning-modal']: ''}`}
          >
            <div
              className={`${stylesModuleLogList['mll-card-title-status']} ${props.error ? stylesModuleLogList['mll-card-title-status-error'] : ''}`}
            >
              <div className={stylesModuleLogList['mll-card-title-status-icon']}></div>
              <div
                className={stylesModuleLogList['mll-card-title-status-text']}
              >
                {props?.error || props?.warning || 'ACTIVE'}
              </div>
            </div>
          </div>
          {props.summaries && Object.keys(props.summaries).length > 0 &&
            <div className={stylesCoreModule['summary-modal-view']}>
              <LogTable
                logs={Object.keys(props.summaries)?.reverse().map((time) => {
                  return (
                    {action: 'Conclusion', timestamp: parseInt(time), id: parseInt(time)}
                  )
                })}
                style={{maxHeight: 'calc(80vh - 155px)'}}
                singleVal={true}
                selectedId={parseInt(selectedSummaryIdRef.current)}
                onClick={(id)=> {
                  setSelectedSummaryId(id)
                }}
              />
              <div className={stylesCoreModule['summary-right']}>
                <div className={stylesCoreModule['summary-right-top']}>
                  <p>SUMMARY</p>
                  <div className={stylesCoreModule['summary-full-right']}>
                    <div className={stylesCoreModule['summary-sub-text']}>
                      <img className={stylesCoreModule['clock-icon']} src={clockClockwise} />
                      <span className={stylesCoreModule['sub-text']}>{Helpers.timeStampToDateAndTime(parseInt(selectedSummaryId))}</span>
                    </div>
                    <ReactMarkdown className={stylesCoreModule['full-summary']}>{props.summaries?.[selectedSummaryIdRef.current]?.summary}</ReactMarkdown>
                    {isLoadingPDF ?
                      <div
                        className={stylesCoreModule['pdf-dling-div']}
                      >
                        <Animation
                          animationState={'generating'}
                          stopAnimation={false}
                          height={'18px'}
                          width={'18px'}
                          className={stylesCoreModule['pdf-dl-anim']}
                        />
                        <span>Downloading PDF...</span>
                      </div> :
                      <div
                        className={stylesCoreModule['pdf-dl-div']}
                        onClick={downloadPDF}
                      >
                        <Icon
                          animation={null}
                          icon={'download-outline'}
                          className={stylesCoreModule['pdf-dl-icon']}
                        />
                        <span>Download PDF</span>
                      </div>
                    }
                    <div>
                      <p style={{marginBottom: 0}}>TASKS</p>
                      <span className={stylesCoreModule['sub-text']}>Tasks used to produce this summary</span>
                    </div>
                  </div>
                </div>
                {summaryLogEntries &&
                  <Table
                    showCount={false}
                    theme={props.theme}
                    id='task table'
                    className={`${stylesCoreModule['mll-table']} ${stylesCoreModule['mll-table-code']}`}
                    entries={
                      summaryLogEntries
                    }
                    columnTitles={[
                      <span
                        key={'header-log'}
                      >
                        Module
                      </span>,
                      <span
                        key={'header-time'}
                      >
                        Task
                      </span>,
                      <span
                        key={'header-time'}
                      >
                        Time
                      </span>,
                    ]}
                  />
                }
              </div>
            </div>
          }
        </Modal2>
      </div>
    </>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
  summaries: state.userReducer.summaries,
})

export default connect(
    mapStateToProps,
    {},
)(CoreModule)
